import styled from 'styled-components';
import { color } from '../../theme';

export const ModalContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
`;

export const ModalDescription = styled.p`
    font-size: 0.875rem;
    color: ${color('text.header')};
    margin: 0;
    line-height: 1.5;
    text-align: center;
    width: 100%;
    max-width: 80%;
    margin: 0 auto;
`;
